<template>
    <div class="handicap_bg" id="Handicap">
      <!-- 成交资讯 -->
      <div class="handicap_title">
        <span  :class="type===1?'on':''" @click="changeType(1)">{{$t('12939')}}</span>
        <span  :class="type===2?'on':''" @click="changeType(2)">{{$t('12940')}}</span>
      </div>
      
      <div class="handicap_handicap" v-if="type===1">
        <div class="handicap_handicap_title">
        <span >{{$t('12939')}}</span>
        </div>
        <div class="handicap_title">
          <div class="handicap_icons">
            
            <span :class="active===1?'on':''" @click="changeBorS(1)" :title="$t('12943')">
            <img :style="upDown===0?'transform: rotateX(180deg)':''" src="@/assets/market/icon_all@2x.png">
            </span>
            
            <span  :class="active===2?'on':''" @click="changeBorS(2)" :title="$t('12941')">
              <img src="@/assets/market/icon_sell@2x.png" alt="" v-if="upDown===1">
              <img src="@/assets/market/icon_buy@2x.png" alt=""  v-if="upDown===0">
            </span>
            <span  :class="active===3?'on':''" @click="changeBorS(3)" :title="$t('12942')">
              <img src="@/assets/market/icon_buy@2x.png" alt=""  v-show="upDown===1">
              <img src="@/assets/market/icon_sell@2x.png" alt="" v-show="upDown===0">
            </span>
          </div>
        </div>
        <ul class="handicap_header">
          <li>{{$t('12925')}}({{tradeInfo.quoteAsset}})</li>

          <li v-if="lang=='zh-cn'||lang=='zh'||lang=='ja'||lang=='ko'">
            {{$t('12944')}}({{tradeInfo.baseAsset}})
          </li>

          <li v-else>
            <span class="langStr">{{$t('12944')}}</span>
            <span class="langStr">({{tradeInfo.baseAsset}})</span>
          </li>

          <li v-if="lang=='zh-cn'||lang=='zh'||lang=='ja'||lang=='ko'">
            {{$t('12945')}}({{tradeInfo.baseAsset}})
          </li>

          <li v-else>
            <span class="langStr">{{$t('12945')}}</span>
            <span class="langStr">({{tradeInfo.baseAsset}})</span>
          </li>
          <!-- ({{tradeInfo.baseAsset}}) -->
        </ul>
        <div class="handicap_handicap_list_all" v-if="active===1">
          <div class="">
            <div class="">
              
              <div class="handicap_item" v-for="(item,i) in asks20" :key="i">
                <div class="handicap_bgprogness2" :style="{transform:`scale3d(${item[1]/fix}, 1, 1)`,'background':upDown===1?'rgba(236, 77, 92, 0.08)':'rgb(107, 185, 109,0.08)'}"  ></div>
                <div class="handicap_data">
                  <div class="" :style="{'color':upDown===0?'rgb(107, 185, 109)':'rgb(236, 77, 92)',display: 'flex',alignItems: 'center'}">
                    {{item[0]|digits2(tickSize)}} 
                  </div>
                  <div class="" >
                    {{item[1]|digits2(stepSize)}}
                  </div>
                  <div class="">
                    {{item[2]|digits2(stepSize)}}
                  </div>
                </div>
              </div> 

              <div class="handicap_item" v-for="i in (20-asks20.length)" >
                <div class="handicap_data">
                  <div class="" style=" display: flex; align-items: center;">
                    --
                  </div>
                  <div class="" >
                    --
                  </div>
                  <div class="">
                    --
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="handicap_renderTitle">
            <em>
              <i :style="{'color':upDown===0?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100>0">{{tradeInfo.askPrice2|digits2(tickSize)}}</i>
              <i :style="{'color':upDown===1?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100<=0">{{tradeInfo.askPrice2|digits2(tickSize)}}</i>

            </em>
            <div class="">
              <img src="@/assets/market/xin.gif" alt="" v-show="!wsIsOp">
              <img src="@/assets/market/xin.png" alt="" v-show="wsIsOp">
            </div>
          </div>
          <div class="">
            <div class="">
              
              <div class="handicap_item" v-for="(item,i) in bids20" :key="i">
                <div class="handicap_bgprogness2" :style="{transform:`scale3d(${item[1]/fix}, 1, 1)`,'background':upDown===0?'rgba(236, 77, 92, 0.08)':'rgb(107, 185, 109,0.08)'}"></div>
                <div class="handicap_data">
                  <div class="" :style="{'color':upDown===1?'rgb(107, 185, 109)':'rgb(236, 77, 92)',display: 'flex',alignItems: 'center'}">
                    {{item[0]|digits2(tickSize)}}
                  </div>
                  <div class="" >
                    {{item[1]|digits2(stepSize)}}
                  </div>
                  <div class="">
                    {{item[2]|digits2(stepSize)}}
                  </div>
                </div>
              </div>  

              <div class="handicap_item" v-for="i in (20-bids20.length)" >
                <div class="handicap_data">
                  <div class="" style=" display: flex; align-items: center;">
                    --
                  </div>
                  <div class="" >
                    --
                  </div>
                  <div class="">
                    --
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="handicap_handicap_list" v-else-if="active===2">
          <div class="handicap_renderTitle">
            <em>
              <!-- <i :style="{'color':upDown===0?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}">{{tradeInfo.askPrice2|digits2(stepSize)}}</i> -->
              <i :style="{'color':upDown===0?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100>0">{{tradeInfo.askPrice2|digits2(tickSize)}}</i>
              <i :style="{'color':upDown===1?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100<=0">{{tradeInfo.askPrice2|digits2(tickSize)}}</i>
            </em>
            <div class="">
              <img src="@/assets/market/xin.gif" alt="" v-show="!wsIsOp">
              <img src="@/assets/market/xin.png" alt="" v-show="wsIsOp">
            </div>
          </div>
          <div class="handicap_HandicapBox2">

            <div class="">
              <div class="">

                <div class="handicap_item" v-for="(item,i) in bids50" :key="i">
                  <div class="handicap_bgprogness2" :style="{transform:`scale3d(${item[1]/fix}, 1, 1)`,'background':upDown===1?'rgba(236, 77, 92, 0.08)':'rgb(107, 185, 109,0.08)'}"></div>
                  <div class="handicap_data">
                    <div class="" :style="{'color':upDown===0?'rgb(107, 185, 109)':'rgb(236, 77, 92)',display: 'flex',alignItems: 'center'}">
                    {{item[0]|digits2(tickSize)}}
                  </div>
                  <div class="" >
                    {{item[1]|digits2(stepSize)}}
                  </div>
                  <div class="">
                    {{item[2]|digits2(stepSize)}}
                  </div>
                  </div>
                </div>
                
              <div class="handicap_item" v-for="i in (50-bids50.length)" >
                <div class="handicap_data">
                  <div class="" style="display: flex; align-items: center;">
                    --
                  </div>
                  <div class="" >
                    --
                  </div>
                  <div class="">
                    --
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>

        </div>
        <div class="handicap_handicap_list" v-else>
          <div class="handicap_HandicapBox2">
          <div class="">
            <div class="">

              <div class="handicap_item" v-for="(item,i) in asks50" :key="i">
                <div class="handicap_bgprogness2" :style="{transform:`scale3d(${item[1]/fix}, 1, 1)`,'background':upDown===0?'rgba(236, 77, 92, 0.08)':'rgb(107, 185, 109,0.08)'}"></div>
                <div class="handicap_data">
                  <div class="" :style="{'color':upDown===1?'rgb(107, 185, 109)':'rgb(236, 77, 92)',display: 'flex',alignItems: 'center'}">
                    {{item[0]|digits2(tickSize)}} 
                    <!-- {{item[0]|digits2(stepSize)}}  -->
                  </div>
                  <div class="" >
                    {{item[1]|digits2(stepSize)}}
                  </div>
                  <div class="">
                    {{item[2]|digits2(stepSize)}}
                  </div>
                </div>
              </div>

              <div class="handicap_item" v-for="i in (50-asks50.length)" >
                <div class="handicap_data">
                  <div class="" style=" display: flex; align-items: center;">
                    --
                  </div>
                  <div class="" >
                    --
                  </div>
                  <div class="">
                    --
                  </div>
                </div>
              </div>

            </div>
          </div>
          </div>
          <div class="handicap_renderTitle">
            <em>
              <!-- <i :style="{'color':upDown===0?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}">{{tradeInfo.askPrice2|digits2(stepSize)}}</i> -->
              <i :style="{'color':upDown===0?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100>0">{{tradeInfo.askPrice2|digits2(tickSize)}}</i>
              <i :style="{'color':upDown===1?'rgb(236, 77, 92)':'rgb(107, 185, 109)'}" v-show="(tradeInfo.askPrice2-tradeInfo.openPrice)/tradeInfo.openPrice*100<=0">{{tradeInfo.askPrice2|digits2(tickSize)}}</i>
            </em>
            <div class="">
              <img src="@/assets/market/xin.gif" alt="" v-show="!wsIsOp">
              <img src="@/assets/market/xin.png" alt="" v-show="wsIsOp">
            </div>
          </div>
        </div>

      </div>
      <div class="handicap_handicap" >
        <div class="handicap_handicap_title">
        <span >{{$t('12940')}}</span>
      </div>
        <ol class="handicap_header">
          <li>{{$t('12946')}}</li>
          <li>{{$t('12925')}}({{tradeInfo.quoteAsset}}) </li>

          <li v-if="lang=='zh-cn'||lang=='zh'||lang=='ja'||lang=='ko'">
            {{$t('12944')}}({{tradeInfo.baseAsset}})
          </li>

          <li v-else>
            <span class="langStr">{{$t('12944')}}</span>
            <span class="langStr">({{tradeInfo.baseAsset}})</span>
          </li>
          <!-- <li>{{$t('12944')}}({{tradeInfo.baseAsset}}) </li> -->
        </ol>
        <div class="handicap_tradeList">
            
            <ul v-for="item in tradeList" :key="item.t">
              <li>{{item.T|fmtDate}}</li>
              <li :class="item.isb?'up':'down'" v-show="upDown===1">{{item.p|digits2(tickSize)}}</li>
              <li :class="item.isb?'down':'up'" v-show="upDown===0">{{item.p|digits2(tickSize)}}</li>
              <li>{{item.q|digits2(stepSize)}}</li>
            </ul>
           
        </div>
      </div>
    </div>
</template>


<script>
import { mapGetters, mapState,mapActions} from 'vuex';
import {recentTrade} from '@/api/wiki'
import socket from "../../tradingview/api/socket";
export default {
name:'Handicap',

data() {
  return {
    lang:'zh-cn',
    socket:null,
    lockReconnect:false,
    visible:false,
    isHaveCode:false,
    type:1,
    active:1,
    isShow:false,
    value:{},
    minWidth:'',
    tradeInfo:{
      quoteAsset:'',
      baseAsset:'',
      askPrice2:'',
      openPrice:'',
    },
    asks20:[],
    asks50:[],
    bids20:[],
    bids50:[],
    aggtradeList:[]
  }
},

computed: {
  ...mapState(['asks','bids','asksDep','bidsDep','trade','fix','tradeList','symbol','upDown','wsIsOp','country','tickSize','stepSize',"baseAsset"]),
  ...mapGetters(['getSymbolTicker']),

},
watch: {
  getSymbolTicker(e){
    let trade=this.trade.replace('/','')
    let info ={}
    info= e.filter(item=>{
      return item.symbol===trade
    })[0]||{}
    if(info.askPrice2!==undefined){
      this.tradeInfo=info
    }

  },
  trade:{
    immediate:true,
    handler(e,oldData){
      let trade=e.replace('/','')
          this.tradeInfo=this.getSymbolTicker.filter(item=>{
              return item.symbol===trade
          })[0]||{}
          this.tradeInfo.askPrice2=this.tradeInfo.askPrice
          if(this.tradeInfo.tickSize){
            this.setQp({tickSize:this.tradeInfo.tickSize,stepSize:this.tradeInfo.stepSize})
          }
      if(this.isHaveCode&&oldData!==undefined&&e!==''){
          this.getTrade(trade,this.country)
      }else if(!this.isHaveCode&&e!==''){
        this.getTrade(trade,this.country)
      }
    }
  },

  symbol(newData,oldData){
    this.unSubscribe(oldData)
    // this.getTrade(newData.toUpperCase(),this.country)
    this.setTradeList({isClear:true})
  },

  asks(e){
    this.asks20=[]
    this.asks20=e
  },
  bids(e){
    this.bids20=[]
    this.bids20=e.slice(0,20)
  },
  asksDep(e){
    this.asks50=[]
    if(e.length>30){
      let arr1= [...e].reverse().slice(0,30)
      this.asks50=[...arr1.reverse(),...this.asks]
    }else{
      this.asks50=[...e,...this.asks]
    }
  },
  bidsDep(e){
    this.bids50=[]
    if(e.length>30){
      let arr1=[...e].reverse().slice(0,30)
      this.bids50=[...arr1.reverse(),...this.bids]
    }else{
      this.bids50=[...e,...this.bids]
    }
  },
  country:{
    immediate:true,
    handler(e){
       if(e!==''){
         this.initWs(e)
        
       }
    }
  }
},
created() {
  // let url='http://192.168.1.84:8066/zh/market/USDT/6392453855120.html'
  let url=location.href

  if(url.includes('.html')){
    this.isHaveCode=true
  }else{
    this.isHaveCode=false
  }
 
},
mounted() {
  this.lang=location.href.split('/')[3]
    window.onresize = () => {
      return (() => {
        this.minWidth=document.documentElement.clientWidth
        this.$nextTick(() => {
          this.headHeight();
        });
      })();
    };
  },
methods: {
  ...mapActions(['setTradeActive','setBaseAsset','setScore','setTrade','setAsks','setBids','setFix','setTradeList','setQp']),
  headHeight() {
    if(this.minWidth>1850){
      this.type=1
    }
  }, 
    // 获取近期成交
    getTrade(data,country){
      // let symbol='BTCUSDT'
      let params={
        symbol:data,
        limit:60
      }
      recentTrade(params,country).then(res=>{
        let data= res.map(item=>{
          let temp = {
              t: item.id,
              T: item.time,
              p: item.price,
              q: item.qty
            };
            return temp;
        })
        this.setTradeList({isClear:true})
        this.setTradeList({tradeList:data.reverse()})
        this.subscribe(this.symbol)
      })
    },
  changeType(e){
    this.type=e
  },
  changeBorS(e){
    this.active=e
  },
  
  initWs(e){
      this.socket= new socket(e)
      this.socket.doOpen();
      this.socket.onClose=this.websocketOnclose;
      this.socket.onError=this.websocketOnerror;
      this.socket.onMessage = this.websocketOnmessage;
    },
    websocketOnmessage(e){
      if(e.data){
        this.setTradeList({tradeList:{
          t:e.data.a+Math.random(),
          T:e.data.T,
          p:e.data.p,
          q:e.data.q,
          isb:e.data.m
        }})
      }

    },
    subscribe(data) {
      let params = {
        id:1,
        method: "SUBSCRIBE",
        params:[ `${data}@aggTrade`]
      }
      this.sendMessage(JSON.stringify(params));
    },
    unSubscribe(data) {
      // 停止订阅，删除过期缓存、缓存时间、缓存状态
      let params = {
        id:1,
        method: "UNSUBSCRIBE",
        params:[ `${data}@aggTrade`]

      }
      this.sendMessage(JSON.stringify(params));
    },
    sendMessage(data){
    if (this.socket.checkOpen()) { //检验websocket是否打开
      this.socket.send(data);
    } else {
      this.socket.send(data);
      this.socket.on('open', () => {
        this.socket.send(data);
      });
    }

    },
    websocketOnerror() {
      console.log("WebSocket连接发生错误");
      this.reconnect();
    },
    websocketOnclose(e) {
      console.log("connection closed (" + e.code + ")");
      this.reconnect();
    },
    reconnect() {
      var that = this;
      if(that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
      console.info("尝试重连...");
      that.socket.destroy()
      that.initWs(that.country);
      that.subscribe(that.symbol)
      that.lockReconnect = false;
      }, 5000);
    },

},
beforeDestroy() {
  
  this.unSubscribe(this.symbol)
  this.socket.destroy();
},
}
</script>

<style lang="less">
    .handicap_bg{
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: space-between;
        flex-wrap: wrap;
        // background: #0E1D2C;
        // background-color: var(--grey700);
        border-radius: 2px;
        
        .handicap_title {
        width: 100%;
        height: 50px;
        text-align: left;
        color: var(--grey200);
        background-color: var(--grey900);
        border-bottom: 1px solid var(--line);
  
        span {
          display: inline-block;
          font-size: 14px;
          padding: 0 16px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          border-top: 2px solid transparent;
          &.on {
            border-top: 2px solid var(--yellow);
            background: var(--grey800);
            color: var(--fontWhite);
          }
        }
      }  

      
      .handicap_handicap {
        
          width: 100%;
          height: 100%;
          background: var(--grey800);
          overflow: hidden;
          .handicap_title{
            height: 36px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            background: var(--grey800);
            border-bottom: 1px solid var(--grey800);
            
            .handicap_icons {
              display: flex;
              align-items: center;
              span {
                padding: 0;
                width: 24px;
                height: 24px;
                margin: 0 8px 0 0;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                line-height: 24px;
                border: 1px solid var(--grey500);
                border-radius: 2px;
                &.on{
                  border-color: var(--yellow);
                  cursor: default;
                }
                &:hover {
                  border-color: var(--yellow);
                }
                img {
                width: 12px;
                height: 12px;
                }
                &:nth-child(1){
                transform: rotateX(180deg);
                }
                // &:nth-child(2){
                // transform: rotateX(180deg);
                // }
                // &:nth-child(3){
                // transform: rotateX(180deg);
                // }
              }
               
              
            }
          }
  
          .handicap_renderTitle {
            background-color: var(--grey800);
            height: 40px;
            padding: 0 16px;
            margin: 2px 0;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid var(--line);
            border-bottom: 1px solid var(--line);
            & i {
              color: var(--grey300);
              font-size: 14px;
              font-weight: 500;
              &:first-child {
                font-size: 16px;
              }
            }
          }
          .handicap_header {
            height: 32px;
            padding: 0 16px;
            margin: 0;
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            & li {
              flex: 0 0 35%;
              font-size: 12px;
              color: var(--grey300);
              
              &:nth-child(1) {
                flex: 0 0 30%;
                text-align: left;
                // text-align: center;
              }
              &:nth-child(2) {
                flex: 0 0 35%;
                text-align: right;
              }
              &:nth-child(3) {
              flex-wrap: nowrap;
                flex: 0 0 35%;
                text-align: right;
                
              }
              .langStr{
                color: var(--grey300);
                display: block;
                // text-align: center;
                // width: 100px;
              }
            }
          }
  
          .handicap_handicap_title {
            height: 50px;
            display: none ;
            line-height: 53px;
            background-color: var(--grey900);
            justify-content: space-between;
            padding: 0 16px;
          }
  
          .handicap_icons {
            display: flex;
            align-items: center;
            span {
              width: 24px;
              height: 24px;
              margin: 0 8px 0 0;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              line-height: 24px;
              border: 1px solid var(--grey500);
              border-radius: 2px;
              cursor: pointer;
              &.on{
                border-color: var(--yellow);
                cursor: default;
              }
              &:hover {
                border-color: var(--yellow);
              }
            }
            & img {
              width: 12px;
              height: 12px;
            }
          }
  
          .handicap_handicap_list_all {
            width: 100%;
            overflow-y: auto;
            height: calc(100% - 122px);
            scrollbar-width: thin;
            scrollbar-color: rgba(127, 143, 164, 0.6) rgba(0, 0, 0, 0.2) ;

            &::-webkit-scrollbar {  
              width: 5px;
              height: 5px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-track {
              width: 5px;
              height: 5px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background-color: rgba(127, 143, 164, 0.6);
              border-radius: 5px;
            }
          }
          .handicap_handicap_list {
            width: 100%;
            overflow: auto;
            height: calc(100% - 122px);
          }
          .handicap_tradeList {
            position: relative;
            height: calc(100% - 85px); 
            // 32px
            overflow: auto;
            scrollbar-width: thin;
            scrollbar-color: rgba(127, 143, 164, 0.6) rgba(0, 0, 0, 0.2) ;
            > ul {
              margin: 0;
              padding: 0 16px;
              width: 100%;
              height: 20px;
              display: flex;
              align-items: center;
            }
            li {
              &.up{
                color:rgb(236,77,92)
              }
              &.down{
                color:rgb(107, 185, 109)
              }

              &:nth-child(1) {
                flex: 0 0 30%;
                text-align: left;
              }
              flex: 0 0 35%;
              
              color: var(--grey200);
              font-size: 12px;
              text-align: right;
            }
          }
          .handicap_HandicapBox2 {
            height: calc(100% - 44px);
            overflow-y: auto;
            scrollbar-width: thin;
            scrollbar-color: rgba(127, 143, 164, 0.6) rgba(0, 0, 0, 0.2) ;
            &::-webkit-scrollbar {
              width: 5px;
              height: 5px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-track {
              width: 5px;
              height: 5px;
              background-color: transparent;
            }
            &::-webkit-scrollbar-thumb {
              background-color: rgba(127, 143, 164, 0.6);
              border-radius: 5px;
            }
          }
          .handicap_bgprogness {
            position: absolute;
            height: 100%;
            width: 100%;
            right: 0;
            top: 0;
            z-index: 1;
            transform-origin: right;
          }
          .handicap_bgprogness2 {
            position: absolute;
            height: 100%;
            width: 100%;
            right: 0;
            top: 0;
            z-index: 1;
            transform-origin: right;
          }
  
          .handicap_item {
            position: relative;
            height: 20px;
            width: 100%;
            overflow: hidden;
            font-size: 12px;
            // fontWeight: 500;
            .handicap_data {
              display: flex;
              align-items: center;
              padding: 0 16px;
              height: 100%;
              position: relative;
              z-index: 1;
              &:hover {
                background-color: var(--grey700);
                & i.delete {
                  visibility: initial;
                }
              }
              & > div {
                height: 100%;
                flex: 0 0 20%;
                font-size: 12px;
                text-align: right;

                color: var(--grey200);
                // &:nth-child(3n + 1) {
                //     text-align: left;
                //     flex: 0 0 30%;
                // }
                &:nth-child(2){
                  text-align: right;
                    flex: 0 0 40%;

                }
                &:nth-child(3){
                  text-align: right;
                    flex: 0 0 40%;

                }
              }
              & i.handicap_delete {
                display: inline-block;
                width: 16px;
                font-size: 16px;
                visibility: hidden;
                color: var(--grey200);
              }
            }
          }
        }
         
        .handicap_loading {
          display: flex;
          width: 100%;
          height: 100%;
          justify-content: center;
          align-items: center;
          color: var(--grey200);
        }
    }
  
      @media screen and (min-width: 1850px) {
         .handicap_handicap{
          margin-left: 6px;
          width: calc(50% - 6px) !important;
          // display: none;
        }
        .handicap_bg{
          background-color: var(--grey700);
        }
        .handicap_handicap_title{
          display: flex !important;
        }
        .handicap_title{
          display: none;
        }

      }
    
  </style>